/* BOOM Easter Egg — triggers on typing "boom" quickly, or Ctrl+Shift+B */
(function () {
  var buffer = [];
  var lastAt = 0;
  var windowMs = 1500;     // max time to type "boom"
  var cooldownMs = 2000;   // don’t retrigger too fast
  var active = false;
  var lastTrigger = 0;

  function inEditable(e) {
    var t = e.target;
    if (!t) return false;
    var tag = (t.tagName || "").toLowerCase();
    if (tag === "input" || tag === "textarea") return true;
    if (t.isContentEditable) return true;
    return false;
  }

  function triggerBoom() {
    var now = Date.now();
    if (now - lastTrigger < cooldownMs || active) return;
    lastTrigger = now;
    active = true;
    document.documentElement.classList.add("boom-shake-active");
    setTimeout(function () {
      document.documentElement.classList.remove("boom-shake-active");
      active = false;
    }, 750); // a bit longer than CSS animation
  }

  // Key combo: Ctrl+Shift+B
  window.addEventListener("keydown", function (e) {
    if (e.ctrlKey && e.shiftKey && (e.key === "B" || e.key === "b")) {
      // prevent from focusing browser bookmarks in some environments
      e.preventDefault();
      triggerBoom();
    }
  }, true);

  // Typing sequence: "b" "o" "o" "m"
  window.addEventListener("keydown", function (e) {
    if (inEditable(e)) return; // don’t interfere with typing in forms

    var now = Date.now();
    if (now - lastAt > windowMs) buffer = []; // too slow, reset
    lastAt = now;

    var k = (e.key || "").toLowerCase();
    // Allow only single-letter keys to avoid arrows/shift/etc.
    if (k.length === 1 && k >= "a" && k <= "z") {
      buffer.push(k);
      if (buffer.length > 4) buffer.shift();

      if (buffer.join("") === "boom") {
        triggerBoom();
        buffer = [];
      }
    }
  });
})();
